import React, { useEffect, useMemo, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { getStudentsByCourse } from "../../controllers/estudiantes/estudiantes.controller";
import HeaderSearchTable from "../Custom/HeaderSearchTable";
import LoaderSmall from "../Loaders/LoaderSmall";
import * as FaIcons from 'react-icons/fa';

const EstudiantesPorCursos = ({selectOption = null, handleViewStudent}) => {
	
	const [filterText, setFilterText] = useState("");
	const [resetPagination, setResetPagination] = useState(false);
	const [dataTable, setDataTable] = useState([]);
	const [dataTableFiltered, setDataTableFiltered] = useState([]);
	const [loading, setLoading] = useState(false);
	
	const searchComponentMemo = useMemo(() => {
		return (
			<HeaderSearchTable
				filterText={filterText}
				setFilterText={setFilterText}
				arrayData={dataTable}
				setArrayFiltered={setDataTableFiltered}
				setResetPagination={setResetPagination}
				placeholder="Buscar estudiante por nombre o apellido"
				columnsToFilter={["nombres", "apellidos"]}
				/>
				);
			}, [filterText, resetPagination]);
			
	
	const columns = useMemo(
		() => [
			{
				name: "#",
				selector: (row, rowIndex) => rowIndex + 1,
				width: "10%",
			},
			{
				name: "Nombres",
				// width: '250px',
				selector: (row) => row.nombres,
				sortable: true,
			},
			{
				name: "Apellidos",
				// width: '250px',
				selector: (row) => row.apellidos,
				sortable: true,
			},
			{
				name: "Progreso del curso",
				width: '250px',
				cell: (row) => (
					<div className="row w-100">
						<div className="col-9">
							<ProgressBar
								className="ge-progress-primary"
								now={row.progreso}
								// now={50}
								max={100}
								min={0}								
							/>
						</div>
						<div className="col-3">
							<span 
								// className="ml-2"
							>
								{row.progreso}%
							</span>
						</div>
					</div>
				),
			},
			{
				name: "Curso Terminado",
				// width: "100px",
				cell: (row) => (
					row.progreso === 100 && (
						<div className="d-flex text-center">
							<img
								src="/images/check-morado.png"
								alt="check"
								style={{ width: "20px" }}
							/>
						</div>
					)
				),
			},
			{
				name: "Acciones",
				cell: (row) => (
					<div className="d-flex">
						<button
							className="btn ge-btn-deg-primary btn-sm mr-2"
							onClick={() => handleViewStudent(row.id_user)}
						>
							<FaIcons.FaEye />
						</button>
					</div>
				)
			}
		],
		[]
	);
	
	useEffect(() => {
		if (selectOption?.panelTitle === "curso" && selectOption?.value) {
			getStudents(selectOption.value);
		}
	}, [selectOption]);
	
	const getStudents = async (idCourse) => {
		setLoading(true);
		try{
			const response = await getStudentsByCourse(idCourse);
			if(response){
				setDataTable(response);
			}
			setLoading(false);
		}catch(error){
			//console.log(error);
			setLoading(false);
		}
	}
	
	return (
		<>
			<DataTable
				className="custom-datatable"
				columns={columns}
				data={
					dataTableFiltered.length > 0 ? dataTableFiltered : dataTable
				}
				subHeader
				subHeaderComponent={searchComponentMemo}
				pagination
				responsive
				progressPending={loading}
				progressComponent={<LoaderSmall />}
				noDataComponent={
					<div className="mt-5 w-100 text-center">
						No hay estudiantes con progreso para este curso.
					</div>
				}
			/>
		</>
	);
};

export default EstudiantesPorCursos;
